<div class="autocomplete" [class.autocomplete--with-icon]="icon">
  <tp-icon [name]="'icons/' + icon" class="autocomplete__icon"></tp-icon>

  <input
    class="tp-control"
    type="search"
    [placeholder]="placeholder"
    [formControl]="ctrl"
    [matAutocomplete]="auto"
    (blur)="onBlur($event)"
  />

  <mat-autocomplete (optionSelected)="onOptionSelected($event)" #auto="matAutocomplete">
    <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option">
      {{ option.text }}
    </mat-option>
  </mat-autocomplete>
</div>
